import { observer } from "mobx-react";
import React, { memo, useState } from "react";
import { app } from "../../App";
import { TransferAction } from "../../eos/actions/TransferAction";
import { L } from "../../l10n/L10n";
import { PackModel } from "../../stores/PackModel";
import AssetImg from "./AssetImg";
import Styles from "./AssetView.module.scss";
import { GameButton, GameButtonStyleType } from "./GameButton";

type AssetViewStakedPropsType = {
	asset: PackModel
}

const AssetViewStakedPack = observer(({ asset }: AssetViewStakedPropsType) => {
	const [btnReady, setBtnReady] = useState(true);

	const onBtnClick = async () => {
		const action = new TransferAction(asset.assetId)
			.setReadyStateAction(setBtnReady)
			.onSuccess(() => app.showInfo(L.common.success));
		await action.execute();
	};

	return (
		<div className={Styles.assetViewContainer}>
			<AssetImg img={asset.img} name={asset.name} />

			<GameButton
				onClick={onBtnClick}
				text={L.gameCards.unpack}
				style={GameButtonStyleType.SMALL}
				extraStyles={Styles.styleAssetButton}
				ready={btnReady}
			/>
		</div>
	);
})

export default AssetViewStakedPack;
